<template>
  <v-dialog v-model="dialog" width="1050px">
    <v-card>
      <v-toolbar card dense dark color="primary">
        <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>
      </v-toolbar>
      <v-card-actions class="justify-center">
        <img
          v-if="dialog"
          alt="POD no disponible"
          @error="error"
          v-bind:src="'data:image/jpeg;base64,'+imgB64"
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    imgB64: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    error() {
      //this.$emit("cerrar");
      this.$toast("POD no disponible", { color: "red" });
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

